import { render, staticRenderFns } from "./marketplaceSetDetails.vue?vue&type=template&id=30199e78&"
import script from "./marketplaceSetDetails.vue?vue&type=script&lang=js&"
export * from "./marketplaceSetDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports